export default {"src":"https://s.sylndr.com/c-8f80a1a/_next/static/media/step2.dc0688f9.svg","height":56,"width":100,"blurWidth":0,"blurHeight":0};